import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import RouterApp from './RouterApp';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <RouterApp />
);

reportWebVitals();
